import request from '@/utils/request'

// 区域删除
export function districtDelete(data) {
  return request({
    url: '/sys/district/delete',
    method: 'post',
    data
  })
}

// 区域新增
export function districtSave(data) {
  return request({
    url: '/sys/district/save',
    method: 'post',
    data
  })
}

// 工种删除
export function professionDelete(data) {
  return request({
    url: '/sys/profession/delete',
    method: 'post',
    data
  })
}

// 工种新增
export function professionSave(data) {
  return request({
    url: '/sys/profession/save',
    method: 'post',
    data
  })
}